import { forwardRef } from 'react';
import { StyledTagsItem } from './styled';

const TagsItem = forwardRef((props, ref) => (
  <StyledTagsItem ref={ref} {...props} />
));

export default TagsItem;
